import T from '../../../../common/components/T';

export const createCashbackInfoGrid = (cashbackMeta) => {
    return {
        thead: {
            data: [
                {
                    title: <T textName='cumulative_total_personal_volume_short-v1' defaultStr='Квалификация' />,
                    name: 'nlo',
                    type: 'text'
                },
                {
                    title: '%',
                    name: 'percent',
                    type: 'text'
                }
            ]
        },
        tbody: {
            data: cashbackMeta?.additional_percent?.map((it) => ({
                nlo: it.volume,
                percent: it?.percent + cashbackMeta?.fixed_percent
            }))
        }
    };
};
